import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'
import { TooltipDisplay, TooltipModule, isElementTruncated } from '@ftr/foundation'

export interface CaseDetails {
  caseNumber: string
  caseTitle: string
}

@Component({
  selector: 'ftr-complex-list-case-details-row',
  templateUrl: './complex-list-case-details-row.component.html',
  styleUrls: ['./complex-list-case-details-row.component.css'],
  standalone: true,
  imports: [CommonModule, TooltipModule],
})
export class ComplexListCaseDetailsRowComponent {
  @Input() caseDetails?: CaseDetails | undefined

  protected readonly tooltipDisplay = TooltipDisplay
  protected readonly isElementTruncated = isElementTruncated
}
